export const GET_LOGBOOK_CONSULTANCY_REQUEST = "GET_LOGBOOK_CONSULTANCY_REQUEST";
export const GET_LOGBOOK_CONSULTANCY_SUCCESS = "GET_LOGBOOK_CONSULTANCY_SUCCESS";
export const GET_LOGBOOK_CONSULTANCY_FAILURE = "GET_LOGBOOK_CONSULTANCY_FAILURE";

export const ADD_LOGBOOK_CONSULTANCY_REQUEST = "ADD_LOGBOOK_CONSULTANCY_REQUEST";
export const ADD_LOGBOOK_CONSULTANCY_SUCCESS = "ADD_LOGBOOK_CONSULTANCY_SUCCESS";
export const ADD_LOGBOOK_CONSULTANCY_FAILURE = "ADD_LOGBOOK_CONSULTANCY_FAILURE";

export const GET_LOGBOOK_CONSULTANCY_BYID_REQUEST = "GET_LOGBOOK_CONSULTANCY_BYID_REQUEST";
export const GET_LOGBOOK_CONSULTANCY_BYID_SUCCESS = "GET_LOGBOOK_CONSULTANCY_BYID_SUCCESS";
export const GET_LOGBOOK_CONSULTANCY_BYID_FAILURE = "GET_LOGBOOK_CONSULTANCY_BYID_FAILURE";

export const EDIT_LOGBOOK_CONSULTANCY_BYID_REQUEST = "EDIT_LOGBOOK_CONSULTANCY_BYID_REQUEST";
export const EDIT_LOGBOOK_CONSULTANCY_BYID_SUCCESS = "EDIT_LOGBOOK_CONSULTANCY_BYID_SUCCESS";
export const EDIT_LOGBOOK_CONSULTANCY_BYID_FAILURE = "EDIT_LOGBOOK_CONSULTANCY_BYID_FAILURE";

export const DELETE_LOGBOOK_CONSULTANCY_BYID_REQUEST = "DELETE_LOGBOOK_CONSULTANCY_BYID_REQUEST";
export const DELETE_LOGBOOK_CONSULTANCY_BYID_SUCCESS = "DELETE_LOGBOOK_CONSULTANCY_BYID_SUCCESS";
export const DELETE_LOGBOOK_CONSULTANCY_BYID_FAILURE = "DELETE_LOGBOOK_CONSULTANCY_BYID_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST"
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS"
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE"

export const GET_CONSULTANCY_BY_ID_REQUEST = "GET_CONSULTANCY_BY_ID_REQUEST"
export const GET_CONSULTANCY_BY_ID_SUCCESS = "GET_CONSULTANCY_BY_ID_SUCCESS"
export const GET_CONSULTANCY_BY_ID_FAILURE = "GET_CONSULTANCY_BY_ID_FAILURE"

export const EXPORT_CONSULTANCY_TABLE_REQUEST = "EXPORT_CONSULTANCY_TABLE_REQUEST"
export const EXPORT_CONSULTANCY_TABLE_SUCCESS = "EXPORT_CONSULTANCY_TABLE_SUCCESS"
export const EXPORT_CONSULTANCY_TABLE_FAILURE = "EXPORT_CONSULTANCY_TABLE_FAILURE"

export const GET_ALL_CONSULTANCY_LOG_REQUEST = "GET_ALL_CONSULTANCY_LOG_REQUEST";
export const GET_ALL_CONSULTANCY_LOG_SUCCESS = "GET_ALL_CONSULTANCY_LOG_SUCCESS";
export const GET_ALL_CONSULTANCY_LOG_FAILURE = "GET_ALL_CONSULTANCY_LOG_FAILURE";

export const RESTORE_CONSULTANCY_LOG_REQUEST = "RESTORE_CONSULTANCY_LOG_REQUEST";
export const RESTORE_CONSULTANCY_LOG_SUCCESS = "RESTORE_CONSULTANCY_LOG_SUCCESS";
export const RESTORE_CONSULTANCY_LOG_FAILURE = "RESTORE_CONSULTANCY_LOG_FAILURE";

export const DELETE_CONSULTANCY_LOG_REQUEST = "DELETE_CONSULTANCY_LOG_REQUEST";
export const DELETE_CONSULTANCY_LOG_SUCCESS = "DELETE_CONSULTANCY_LOG_SUCCESS";
export const DELETE_CONSULTANCY_LOG_FAILURE = "DELETE_CONSULTANCY_LOG_FAILURE";

export const UPDATE_CONSULTANCY_ENTITY_PARAMS_SUCCESS ="UPDATE_CONSULTANCY_ENTITY_PARAMS_SUCCESS";
export const UPDATE_CONSULTANCY_ENTITY_PARAMS_FAILURE ="UPDATE_CONSULTANCY_ENTITY_PARAMS_FAILURE";

